import { type FC } from "react";

import { type Filters } from "../../../utils/queryUtils";
import { type FilterFormPropsBase } from "../types/props";
import { FilterFormBuilder, type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "../../../enums/filterViewTypes";
import { EmailsFilterEnum } from "../../../features/Library/Communications/Emails/types/models";

export interface EmailFilterFormProps {
  filterOptions: Filters;
  updateFilter: (filter: Filters) => void;
  filter: Filters;
}
export interface EmailFilterFormProps extends FilterFormPropsBase<EmailsFilterEnum> {}

export const EmailFilterForm: FC<EmailFilterFormProps> = ({
  filterOptions,
  filter,
  onValidationChange,
  updateFilter,
}) => {
  const filters: FilterItemBase<EmailsFilterEnum>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: EmailsFilterEnum.DateCreated,
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: EmailsFilterEnum.DateModified,
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: EmailsFilterEnum.Publishers,
      placeholder: "All Publishers",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: EmailsFilterEnum.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Software Applications",
      propertyName: EmailsFilterEnum.SoftwareApplications,
      placeholder: "All Applications",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: EmailsFilterEnum.Labels,
      placeholder: "All Labels",
    },
  ];

  return (
    <FilterFormBuilder
      filterOptions={filterOptions}
      filter={filter}
      updateFilter={updateFilter}
      items={filters}
      onValidationChange={onValidationChange}
    />
  );
};
